module.exports = __webpack_public_path__ + "static/media/product_12.273016d2.jpg";